import {inject, Injectable} from '@angular/core';
import {environment} from '@environments/environment.prod';
import {map, Observable} from 'rxjs';
import {
  GetUsuryRateUseCasePort
} from '@features/setting/application/use_cases/get-usury-rate/get-usury-rate.use-case.port';
import {
  GetUsuryRatePayloadDto
} from '@features/setting/application/use_cases/get-usury-rate/dto/get-usury-rate.payload.dto';
import {
  GetUsuryRateResponseDto
} from '@features/setting/application/use_cases/get-usury-rate/dto/get-usury-rate.response.dto';
import {ClientHttpPort} from '@shared/application/ports/http/client.http.port';
import {LocalStoragePort} from '@shared/application/ports/storage/local.storage.port';
import {NavigationPort} from '@shared/application/ports/navigation/navigation.port';
import {
  GetUsuryRateHttpPayloadDto
} from '@features/setting/infrastructure/http/get-usury-rate/get-usury-rate.http.payload.dto';
import {
  GetUsuryRateHttpResponseDto
} from '@features/setting/infrastructure/http/get-usury-rate/get-usury-rate.http.response.dto';
import {
  GetUsuryRateHttpMapper
} from '@features/setting/infrastructure/http/get-usury-rate/get-usury-rate.http.mapper';

@Injectable()
export class GetUsuryRateHttpAdapter implements GetUsuryRateUseCasePort {

  private readonly url = environment.uri;
  private readonly http = inject(ClientHttpPort);
  private readonly localStoragePort = inject(LocalStoragePort);
  private readonly navigationPort = inject(NavigationPort);

  public execute(payload: GetUsuryRatePayloadDto): Observable<GetUsuryRateResponseDto> {
    const suffix = this.localStoragePort.getByKey("_suffix");
    return this.http.get<GetUsuryRateHttpResponseDto>(`${this.url}usury-rate?suffix_database=${suffix}`, GetUsuryRateHttpMapper.toInfra(payload))
      .pipe(map(GetUsuryRateHttpMapper.toResponse)
      )
  }

}
